import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import { GroupExclamationIcon } from 'components/Icons/GroupExclamation'
import {
    ButtonAction,
    ButtonsContainer,
    ContentContainer,
    dialogPanel,
    dialogTitle
} from './styles'

interface GroupUndoTreatmentModalProps {
    isOpen: boolean
    handleCloseModal: () => void
    handleConfirmUndo: () => void
    treatmentStatus: 'started' | 'not_started'
    selectedCount: number
}

const GroupUndoTreatmentModal: React.FC<GroupUndoTreatmentModalProps> = ({
    isOpen,
    handleCloseModal,
    handleConfirmUndo,
    treatmentStatus,
    selectedCount
}) => {
    const isTreatmentStarted = treatmentStatus === 'started'
    
    // Altura dinâmica baseada no status do tratamento
    const modalHeight = isTreatmentStarted ? '441px' : '417px'
    
    const getSubtitle = () => {
        return isTreatmentStarted ? 'Tratamento iniciado' : 'Tratamento não iniciado'
    }
    
    const getBodyText = () => {
        if (isTreatmentStarted) {
            return [
                'Há dados de tratamento já registrados, por isso ao remover todas \nas notificações, o tratamento em grupo será desfeito, e todas as \nnotificações continuarão com o tratamento em andamento de \nforma individual, ficarão em seu nome. \nNão será possível desfazer essa ação.',
                'Tem certeza que deseja desfazer o tratamento em grupo?'
            ]
        } else {
            return [
                'Não há dados de tratamento registrados, por isso ao remover todas \nas notificações, o tratamento em grupo será desfeito, e todas as \nnotificações voltarão para o status aguardando tratamento. \nNão será possível desfazer essa ação.',
                'Tem certeza que deseja desfazer o tratamento em grupo?'
            ]
        }
    }

    const renderTextWithLineBreaks = (text: string) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                {index < text.split('\n').length - 1 && <br />}
            </React.Fragment>
        ))
    }

    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-group-undo-treatment-modal"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel(modalHeight)}>
                                    <Dialog.Title
                                        as="h3"
                                        className={dialogTitle}
                                    >
                                        <div className="flex flex-col items-center w-full mb-4">
                                            <GroupExclamationIcon />
                                            <p className="text-[#F0B323] text-[20px] font-semibold mt-4">
                                                Desfazer tratamento em grupo
                                            </p>
                                            <p className="text-black text-[14px] font-semibold">
                                                {getSubtitle()}
                                            </p>
                                        </div>
                                    </Dialog.Title>
                                    
                                    <ContentContainer>
                                        <div className="text-[16px] text-gray-700 mb-2 space-y-4">
                                            {getBodyText().map((text, index) => (
                                                <p key={index} className="text-center">
                                                    {renderTextWithLineBreaks(text)}
                                                </p>
                                            ))}
                                        </div>
                                        
                                        <ButtonsContainer>
                                            <ButtonAction
                                                onClick={handleCloseModal}
                                                type="button"
                                                className="text-blueTheme text-sm border border-blueTheme"
                                            >
                                                Cancelar remoção
                                            </ButtonAction>
                                            <ButtonAction
                                                onClick={handleConfirmUndo}
                                                className="bg-blueTheme text-white text-sm"
                                            >
                                                Desfazer tratamento em grupo
                                            </ButtonAction>
                                        </ButtonsContainer>
                                    </ContentContainer>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export { GroupUndoTreatmentModal } 